import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, Box, CssBaseline } from "@mui/material";

import DetailsPageHeader from "../../../../common/DetailsPageHeader";
import { mainLayoutStyles, showNotification } from "../../../../constants";
import Sidebar from "../../../../common/Sidebar";
import {
  AdminDetailsBottomCardSection,
  AdminDetailsTopCardSection,
} from "../../components/components";
import { updateAdmin } from "../../hooks/AdminsHook";
import { useAdminsContext } from "../../../../providers/OrganizationAdmin/AdminsProvider";
import { Toast } from "../../../../common/alert";
import { useAuth } from "../../../../hooks";
import {
  getAuth,
  updatePassword as updateFirebasePassword,
  updatePassword,
} from "firebase/auth";

const AdminDetailsContainer = () => {
  const { currentUser } = useAuth();
  const { handleGetAllAdmins, setLoading, loading } = useAdminsContext();

  const location = useLocation();
  const navigate = useNavigate();
  const [adminDetails, setAdminDetails] = useState(location?.state?.adminDetails || {});
  const [editEnabled, setEditEnabled] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  useEffect(() => {
    // Check if we have no data - redirect to parent page
    if (!location?.state?.adminDetails?.id) {
      navigate('/admins', { replace: true });
      return;
    }

    setAdminDetails(location.state.adminDetails);
  }, [location.state, navigate]);

  // Don't render anything if we don't have valid admin data
  if (!adminDetails?.id) {
    return null;
  }

  const handleUpdateAdmin = async (role) => {
    try {
      setLoading(true);
      let temp = {
        firstName: adminDetails?.firstName ?? "",
        lastName: adminDetails?.lastName ?? "",
        userName: adminDetails?.userName ?? "",
        status: adminDetails?.status ?? "",
        role: adminDetails?.role ?? "",
        notifications: adminDetails?.notifications !== undefined ? adminDetails?.notifications : true,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      let responseTemp = await updateAdmin(adminDetails.id, temp);
      if (newPassword !== "") {
        const auth = getAuth();
        const user = auth.currentUser;
        await updatePassword(user, newPassword);
      }
      console.log("update admin response:", responseTemp);
      await handleGetAllAdmins();
      setEditEnabled(false);
      showNotification("Admin updated successfully.");
      // Toast("success", "admin updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating admin", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={"User Details"}
        bgColor="#fff"
        buttonText={
          currentUser?.role === "super"
            ? "Edit"
            : currentUser?.role === "manager" &&
              (adminDetails?.role === "standard" ||
                adminDetails?.role === "moderator")
            ? "Edit"
            : undefined
        }
        // buttonText={"Edit"}
        editEnabled={editEnabled}
        setEditEnabled={setEditEnabled}
        cancelButton={editEnabled ? true : false}
        handleSave={() => handleUpdateAdmin()}
        loading={loading}
      />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*Data card/container section*/}
          <AdminDetailsTopCardSection
            adminDetails={adminDetails}
            setAdminDetails={setAdminDetails}
            editEnabled={editEnabled}
            newPassword={newPassword}
            setNewPassword={setNewPassword}
          />
          {/*Date Added, Last Login card/container section*/}
          <AdminDetailsBottomCardSection
            adminDetails={adminDetails}
            setAdminDetails={setAdminDetails}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDetailsContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
